// ================================================================
// Topbar
// ================================================================

import './topbar.css';
import { t, getLanguage, setLanguage, getAvailableLanguages } from '../../i18n/index.js';
import { icon, escapeHtml } from '../../utils/dom.js';
import { events, EVENTS } from '../../core/events.js';
import { logout } from '../../core/auth.js';

let containerEl = null;

export function renderTopbar(container) {
  containerEl = container;
  draw();

  // re-render وقتی زبان عوض می‌شه
  events.on(EVENTS.LANGUAGE_CHANGED, draw);
}

function draw() {
  const langs = getAvailableLanguages();
  const current = getLanguage();
  const currentLang = langs.find(l => l.code === current);

  containerEl.innerHTML = `
    <div class="topbar-left">
      <button class="topbar-icon-btn" data-action="back">
        ${icon('arrow_back', 20)}
      </button>
      <span class="topbar-title">${t('app.scenarioName')}</span>
      <button class="topbar-icon-btn" data-action="settings" title="${t('topbar.settings')}">
        ${icon('tune', 18)}
      </button>
    </div>

    <div class="topbar-right">
      <!-- Language switcher -->
      <div class="lang-switcher" id="lang-switcher">
        <button class="lang-trigger" data-action="toggle-lang">
          ${icon('language', 16)}
          <span class="lang-label">${escapeHtml(currentLang.label)}</span>
          ${icon('expand_more', 14)}
        </button>
        <div class="lang-menu" id="lang-menu">
          ${langs.map(lang => `
            <button class="lang-option ${lang.code === current ? 'active' : ''}" data-lang="${lang.code}">
              <span class="lang-option-label">${escapeHtml(lang.label)}</span>
              <span class="lang-option-name">${escapeHtml(lang.name)}</span>
              ${lang.code === current ? `<span class="lang-option-check">${icon('check', 16)}</span>` : ''}
            </button>
          `).join('')}
        </div>
      </div>

      <button class="topbar-btn">
        ${icon('share', 18)}
        ${t('topbar.share')}
      </button>
      <button class="topbar-btn">
        ${icon('help', 18)}
        ${t('topbar.help')}
      </button>
      <button class="topbar-icon-btn" data-action="logout" title="${t('topbar.logout')}">
        ${icon('logout', 18)}
      </button>
    </div>
  `;

  attachHandlers();
}

function attachHandlers() {
  const switcher = containerEl.querySelector('#lang-switcher');
  const trigger = containerEl.querySelector('[data-action="toggle-lang"]');
  const menu = containerEl.querySelector('#lang-menu');

  // باز/بسته کردن
  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    switcher.classList.toggle('open');
  });

  // انتخاب زبان
  containerEl.querySelectorAll('.lang-option').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.stopPropagation();
      const lang = btn.dataset.lang;
      switcher.classList.remove('open');
      await setLanguage(lang);
      // تمام UI با event LANGUAGE_CHANGED خودکار re-render می‌شه
      // (Topbar از طریق event listener که بالا register کردیم)
      // اما sidebar و bottombar هنوز نه — اونا رو هم باید listener داشته باشن.
      // برای الان: یه trick ساده — رویداد می‌فرستیم که همه گوش بدن
    });
  });

  // back — برگشت به نمای کلیِ شرکت‌ها
  const backBtn = containerEl.querySelector('[data-action="back"]');
  backBtn?.addEventListener('click', () => events.emit(EVENTS.SHOW_OVERVIEW));

  // logout — session رو پاک کن و برگرد به gate (reload → bootstrap → gate)
  const logoutBtn = containerEl.querySelector('[data-action="logout"]');
  logoutBtn?.addEventListener('click', async () => {
    logoutBtn.disabled = true;
    await logout();
    location.reload();
  });

  // بستن با کلیک بیرون
  document.addEventListener('click', () => {
    switcher.classList.remove('open');
  });
}
